export const PostType = {
  Article: 'article',
  Text: 'text'
} as const;

export type PostType = (typeof PostType)[keyof typeof PostType];

export const PostStatus = {
  Draft: 'draft',
  Published: 'published',
  Deleted: 'deleted'
} as const;

export type PostStatus = (typeof PostStatus)[keyof typeof PostStatus];

export const PostElementType = {
  BulletList: 'bulletList',
  Heading: 'heading',
  Image: 'documentImage',
  ListItem: 'listItem',
  OrderedList: 'orderedList',
  Paragraph: 'paragraph',
  Text: 'text',
  Title: 'title'
} as const;

export type PostElementType = (typeof PostElementType)[keyof typeof PostElementType];
